/**
 * Dashboard Service
 */
import { getApiClient } from '../apiClient';
import { DASHBOARD_ENDPOINTS } from '../endpoints';
import type {
    GetRevenueGraphResponse,
    GetRevenueGraphParams,
    GetUserGraphResponse,
    GetUserGraphParams,
    GetSubscriptionGraphResponse,
    GetSubscriptionGraphParams,
    GetDashboardStatsResponse,
} from '../types/dashboard.types';

export const dashboardService = {
    /**
     * Get dashboard summary stats
     */
    getDashboardStats: (): Promise<GetDashboardStatsResponse> => {
        return getApiClient().get(DASHBOARD_ENDPOINTS.getDashboardStats);
    },

    /**
     * Get revenue graph data
     */
    getRevenueGraph: (params: GetRevenueGraphParams): Promise<GetRevenueGraphResponse> => {
        const queryParams = new URLSearchParams();
        if (params.type) {
            queryParams.append('type', String(params.type));
        }
        const url = `${DASHBOARD_ENDPOINTS.getRevenueGraph}?${queryParams.toString()}`;
        return getApiClient().get(url);
    },

    /**
     * Get user graph data
     */
    getUserGraph: (params: GetUserGraphParams): Promise<GetUserGraphResponse> => {
        const queryParams = new URLSearchParams();
        if (params.type) {
            queryParams.append('type', String(params.type));
        }
        const url = `${DASHBOARD_ENDPOINTS.getUserGraph}?${queryParams.toString()}`;
        return getApiClient().get(url);
    },

    /**
     * Get subscription graph data
     */
    getSubscriptionGraph: (params: GetSubscriptionGraphParams): Promise<GetSubscriptionGraphResponse> => {
        const queryParams = new URLSearchParams();
        if (params.type) {
            queryParams.append('type', String(params.type));
        }
        const url = `${DASHBOARD_ENDPOINTS.getSubscriptionGraph}?${queryParams.toString()}`;
        return getApiClient().get(url);
    },
};
